import request from '@/utils/request'

// 查询全区易涝点列表
export function listQqyld(query) {
  return request({
    url: '/zhfy/qqyld/list',
    method: 'get',
    params: query
  })
}

// 查询全区易涝点详细
export function getQqyld(id) {
  return request({
    url: '/zhfy/qqyld/' + id,
    method: 'get'
  })
}

// 新增全区易涝点
export function addQqyld(data) {
  return request({
    url: '/zhfy/qqyld',
    method: 'post',
    data: data
  })
}

// 修改全区易涝点
export function updateQqyld(data) {
  return request({
    url: '/zhfy/qqyld',
    method: 'put',
    data: data
  })
}

// 删除全区易涝点
export function delQqyld(id) {
  return request({
    url: '/zhfy/qqyld/' + id,
    method: 'delete'
  })
}
